import React from 'react';
import aboutImg from "../images/aboutus.png";
import supercodingbitsPortfolio from "../images/supercodingbitsPortfolio.png";
import supercodingbitsSimpleCode from "../images/supercodingbitsSimpleCode.png";
import supercodingbitsuielements from "../images/supercodingbitsuielements.png";
import './aboutus.scss'

const Aboutus = () => {
	const ProgrammingLangageData = [
		{
			id: 1,
			title: 'SuperCodingBits | Portfolio',
			description:
				'Explore a collection of innovative projects crafted with precision and passion. At SuperCodingBits, we turn ideas into functional, high-quality code. From web applications to creative experiments, this portfolio showcases our commitment to excellence in development. Dive in and get inspired!',
			image: supercodingbitsPortfolio,
		},
		{
			id: 2,
			title: 'SuperCodingBits | Simple Code',
			description:
				'Writing clean, efficient, and easy-to-understand code is at the heart of great development. SuperCodingBits | Simple Code focuses on elegant solutions, best practices, and minimal yet powerful implementations. Simplify complexity and code smarter!',
			image: supercodingbitsSimpleCode,
		},
		{
			id: 3,
			title: 'SuperCodingBits | UI Elements',
			description:
				'A curated collection of beautifully designed and highly functional UI elements. At SuperCodingBits, we craft user-friendly components that enhance the look and feel of web applications. Explore buttons, forms, cards, and more—built for seamless integration and a smooth user experience. Elevate your UI with precision and style!',
			image: supercodingbitsuielements,
		},
	];
	
	return (
		<>
			<div className="mainAboutus">
				<div className="subAboutus">
					<div className="Aboutus">
						<div class="about-container">
							<img src={aboutImg} alt="SuperCodingBits"/>
							<div class="about-text">
								<p><strong> Hello learners, </strong></p>
								<p><strong>@SuperCodingBits</strong> is the perfect YouTube channel to learn how to develop stunning front-end UIs using React JS! Whether you're starting from scratch or already have some experience, we provide step-by-step guidance to help you build beautiful, responsive, and user-friendly interfaces. From creating reusable components and managing layouts with CSS to exploring advanced UI patterns, we cover everything you need to design modern, interactive web
									applications.
									Join us to master the art of front-end development and bring your creative ideas to life with React!</p>
							</div>
						</div>
						<div className="mainProgrammingLanguage">
							<div className="subProgrammingLanguage">
								{ProgrammingLangageData.map ((item) => (
									<div key={item.id} className="ProgrammingLanguage">
										<div className="ListProgrammingLanguage">
											<div className="Details">
												<h3>{item.title}</h3>
												<p>{item.description}</p>
											</div>
										</div>
										<div className="ListProgrammingLanguage">
											<img src={item.image} alt={item.title}/>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Aboutus;